<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-container fluid v-if="perguntasEnquete.length > 0">
                    <v-layout wrap>
                        <v-flex xs12 md12>
                            <v-row align="center" justify="center">
                                <v-img max-width="500" :src="require('@/assets/logo_onboarding.png')"></v-img>
                            </v-row>
                        </v-flex>
                    </v-layout>
                </v-container>                

                <material-card icon="mdi-content-copy" :title="tituloEnquete" :text="textoEnquete" >         
                    <v-form id="frmEnquete" ref="frmEnquete">
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12 md12>
                                    <v-row v-for="(pergunta, indicePergunta) in perguntasEnquete" :key="pergunta.id">
                                        <v-flex xs12 md12>
                                            <span class="numeroPergunta">{{pergunta.ordem}}</span>
                                            <span class="textoPergunta"> - {{aplicarTraducaoPergunta(indicePergunta)}}</span>
                                        </v-flex> 

                                        <template v-if="pergunta.indicadorMultiplaEscolha">
                                            <v-flex v-for="(atributo, indiceAtributo) in pergunta.listaValores.atributo" :key="atributo.id" sm4 xs4 md4 lg4 grid-list-md >
                                                <v-checkbox v-model="checkboxOptions[`opcoes${pergunta.ordem}`]" :name="`resposta-${pergunta.ordem}`" 
                                                    :value="atributo.id" :label="aplicarTraducaoAtributo(indicePergunta, indiceAtributo)" class="mx-2"
                                                    :rules="checkboxRules"></v-checkbox>                                                    
                                            </v-flex>                                                 
                                        </template>                                   

                                        <template v-else-if="pergunta.listaValores != null">
                                            <template v-if="pergunta.listaValores.atributo.length > 8">
                                                <v-flex sm12 xs12 md12 lg12 grid-list-md>
                                                    <v-select v-if="pergunta.indicadorMandatorio" :ref="`resposta-${pergunta.ordem}`" :items="selectOptions(indicePergunta)" 
                                                        item-value="id" item-text="descricao" :rules="selectRules">
                                                    </v-select>                    

                                                    <v-select v-else :ref="`resposta-${pergunta.ordem}`" :items="selectOptions(indicePergunta)" 
                                                        item-value="id" item-text="descricao" >
                                                    </v-select>                                                          
                                                </v-flex>   
                                            </template>  

                                            <template v-else>
                                                <v-flex sm12 xs12 md12 lg12 grid-list-md>
                                                    <v-radio-group row v-if="pergunta.indicadorMandatorio" :rules="radioRules">
                                                        <v-radio :name="`resposta-${pergunta.ordem}`" v-for="(atributo, indiceAtributo) in pergunta.listaValores.atributo" :key="atributo.id"
                                                            :label="aplicarTraducaoAtributo(indicePergunta, indiceAtributo)" :value="atributo.id"></v-radio>
                                                    </v-radio-group>                                             

                                                    <v-radio-group row v-else>
                                                        <v-radio :name="`resposta-${pergunta.ordem}`" v-for="(atributo, indiceAtributo) in pergunta.listaValores.atributo" :key="atributo.id"
                                                            :label="aplicarTraducaoAtributo(indicePergunta, indiceAtributo)" :value="atributo.id"></v-radio>
                                                    </v-radio-group>                                                                                                 
                                                </v-flex>   
                                            </template>  
                                        </template>   

                                        <template v-else>
                                            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                                                <v-textarea v-if="pergunta.indicadorMandatorio" :name="`resposta-${pergunta.ordem}`" multi-line :rules="textareaRules"></v-textarea>
                                                <v-textarea v-else :name="`resposta-${pergunta.ordem}`" multi-line></v-textarea>
                                            </v-flex>
                                        </template>                                      
                                    </v-row>
                                </v-flex>

                                <v-flex v-if="perguntasEnquete.length > 0" class="d-flex justify-center">
                                    <v-btn color="red" @click="btnClear_OnClick">
                                        <v-icon left>mdi-restore</v-icon> 
                                        {{limpar}}
                                    </v-btn>                          

                                    <v-btn color="green" @click="btnConfirm_OnClick">
                                        <v-icon left>mdi-check</v-icon> 
                                        {{confirmar}}
                                    </v-btn>                                                   
                                </v-flex>                                        
                            </v-layout>
                        </v-container>
                    </v-form>   
                </material-card>
            </v-flex>
        </v-layout>              
    </v-container>   
</template>

<script>
import { mapMutations } from 'vuex'
import FormMixin from '@/mixin/form'

import EnqueteRespostaApi from '@/api/workspace/corporativo/enquete/resposta'
import EnqueteApi from '@/api/workspace/corporativo/enquete/enquete'
import EnqueteListaValoresApi from '@/api/workspace/corporativo/enquete/listavalores'

import ModelReposta from '@/model/cadastro/enquete/Resposta'
import ModelRepostaPergunta from '@/model/cadastro/enquete/RespostaPergunta'

export default {
    mixins: [ FormMixin ],  
    data () {
        return {
            enquete: null, 
            resposta: new ModelReposta().returnModel(),
            tituloEnquete: null, 
            textoEnquete: null,
            checkboxRules: [
                value => {
                    if(value == null || value.length == 0)
                        return this.selecionarAoMenosUmaOpcao;

                    return true;
                }
            ],                
            radioRules: [
                value => {
                    if(value == null)
                        return this.campoObrigatorio;

                    return true;
                }
            ],                              
            selectRules: [
                value => value != undefined || this.campoObrigatorio,
            ],            
            textareaRules: [
                value => !!value || this.campoObrigatorio,
            ],
            checkboxOptions: {}
        }
    },
    computed: { 
        perguntasEnquete(){
            if(this.enquete != null){
                return this.enquete.pergunta;
            }
            else 
                return [];            
        }, 
        campoObrigatorio(){
            return this.$t("Views.Corporativo.Enquete.Resposta.campo-obrigatorio")
        },
        selecionarAoMenosUmaOpcao(){
            return this.$t("Views.Corporativo.Enquete.Resposta.campo-multipla-obrigatorio")
        },        
        confirmar(){
            return this.$t("Common.confirm")
        }, 
        limpar(){
            return this.$t("Common.clear")
        },
        tituloSucesso(){
            return this.$t("Views.Corporativo.Enquete.Resposta.mensagem-sucesso-titulo");
        },
        mensagemSucesso(){
            return this.$t("Views.Corporativo.Enquete.Resposta.mensagem-sucesso-texto");
        }                              
    },
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
    },
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },
    async mounted(){           
        const loading = this.showLoading();
        await this.listarEnqueteResposta();
        loading.close();      
    },        
    methods:{      
        ...mapMutations("app", ["setPageNotFoundDescription"]),
        setLocale(){
            if(this.enquete != null){
                this.$set(this, "tituloEnquete", this.enquete.nome);

                for(let count = 0; count < this.enquete.traducao.length; count++){
                    if(this.$locale == this.enquete.traducao[count].linguagem.codigoUnico){
                        this.$set(this, "tituloEnquete", this.enquete.traducao[count].nome);
                        break;
                    }
                }

                this.$set(this, "textoEnquete", this.enquete.descricao.replace(/(?:\r\n|\r|\n)/g, '<br />'));
                for(let count = 0; count < this.enquete.traducao.length; count++){
                    if(this.$locale == this.enquete.traducao[count].linguagem.codigoUnico){
                        this.$set(this, "textoEnquete", this.enquete.traducao[count].descricao.replace(/(?:\r\n|\r|\n)/g, '<br />'));
                        break;
                    }
                }
            }
            else {
                this.$set(this, "tituloEnquete", null);
                this.$set(this, "textoEnquete", null);
            }
        },           
        async listarEnqueteResposta(){
            const enquete = await EnqueteRespostaApi.listarPorId(this.$route.params.id).catch(erro => this.showSnackbarError(erro.error));            

            if(enquete.success) {
                if(enquete.data == null){    
                    this.setPageNotFoundDescription(this.$t("Views.Corporativo.Enquete.Resposta.enquete-inexistente"));
                    this.$router.push("/pagina-nao-encontrada");
                }
                else{
                    await this.listarEnquete(enquete.data);
                }
            }
            else {                        
                this.showSnackbarError(enquete.error);
                throw new Error(enquete.error[0].userMessage);
            }
        },
        async listarEnquete(enqueteResposta){
            this.resposta.usuario = this.$store.state.app.user;
            
            this.$set(this.resposta, "id", enqueteResposta.id);            
            const enquete = await EnqueteApi.listarPorId(enqueteResposta.enquete.id).catch(erro => this.showSnackbarError(erro.error));            

            if(enquete.success) {
                let repostaPergunta = [];
                this.$set(this.resposta, "enquete", enquete.data);
                
                for(let count = 0; count < enquete.data.pergunta.length; count++){
                    let pergunta = enquete.data.pergunta[count];
                    let resposta = new ModelRepostaPergunta().returnModel();

                    resposta.resposta = { id: enqueteResposta.id };
                    resposta.pergunta = pergunta;
                    repostaPergunta.push(resposta);

                    if(pergunta.listaValores != null){
                        const listaValores = await EnqueteListaValoresApi.listarPorId(pergunta.listaValores.id).catch(erro => this.showSnackbarError(erro.error)); 
                        
                        if(listaValores.success) {
                            if(pergunta.indicadorMultiplaEscolha){
                                this.$set(this.checkboxOptions, `opcoes${pergunta.ordem}`, []);
                            }

                            enquete.data.pergunta[count].listaValores = listaValores.data;
                        }
                        else {
                            this.showSnackbarError(listaValores.error);
                            throw new Error(listaValores.error[0].userMessage);
                        }                               
                    }
                }

                this.$set(this.resposta, "respostaPergunta", repostaPergunta);
                this.enquete = enquete.data;

                this.setLocale();
            }
            else {                        
                this.showSnackbarError(enquete.error);
                throw new Error(enquete.error[0].userMessage);
            } 
        },     
        async inserir(enqueteResposta){
            const self = this;

            const processing = self.showProcessing();
            const resultado = await EnqueteRespostaApi.inserir(enqueteResposta).catch(erro => self.showSnackbarError(erro.error));
            
            if(resultado.success)
                self.showMessage(
                    self.tituloSucesso, 
                    self.mensagemSucesso,
                    () => self.$router.push("/")
                );                

            else if(resultado.validationException)
                self.showError("Erro de validação na inclusão da resposta", result.error);

            processing.close(); 
        },     
        aplicarTraducaoPergunta(indicePergunta){
            const locale = localStorage.getItem("locale");
            const pergunta = this.enquete.pergunta[indicePergunta];
            
            let descricao = pergunta.descricao;
            for(let count = 0; count < pergunta.traducao.length; count++){
                if(locale == pergunta.traducao[count].linguagem.codigoUnico){
                    descricao = pergunta.traducao[count].descricao;
                    break;
                }
            }

            return descricao;
        },
        aplicarTraducaoAtributo(indicePergunta, indiceAtributo){
            const locale = localStorage.getItem("locale");
            const atributo = this.enquete.pergunta[indicePergunta].listaValores.atributo[indiceAtributo];
            
            let descricao = atributo.descricao;
            for(let count = 0; count < atributo.traducao.length; count++){
                if(locale == atributo.traducao[count].linguagem.codigoUnico){
                    descricao = atributo.traducao[count].descricao;
                    break;
                }
            }

            return descricao;
        },        
        selectOptions(indicePergunta){
            const locale = localStorage.getItem("locale");
            const pergunta = this.enquete.pergunta[indicePergunta];
            
            let options = [];
            for(let count = 0; count < pergunta.listaValores.atributo.length; count++){
                let atributo = pergunta.listaValores.atributo[count];

                for(let count = 0; count < atributo.traducao.length; count++){
                    if(locale == atributo.traducao[count].linguagem.codigoUnico){
                        atributo.descricao = atributo.traducao[count].descricao;
                        break;
                    }
                }

                options.push(atributo);
            }

            return options;
        },
        confirmarCallback(){
            this.$set(this.messageBox, "show", false);
            this.$router.push("/");
        },   
        btnClear_OnClick(){
            this.$refs.frmEnquete.reset();
        },
        btnConfirm_OnClick(){
            if(this.enquete == null) return;
            this.$refs.frmEnquete.validate();
            const form = document.getElementById("frmEnquete")

            let consistente = true;
            for(let cont = 0; cont < this.enquete.pergunta.length; cont++){
                const pergunta = this.enquete.pergunta[cont];
                if(pergunta.indicadorMultiplaEscolha){
                    let valor = 0;
                    const listaCheckbox = form.querySelectorAll(`input[name='resposta-${pergunta.ordem}']`);

                    for(let contCheckBox = 0; contCheckBox < pergunta.listaValores.atributo.length; contCheckBox++){
                        const atributo = pergunta.listaValores.atributo[contCheckBox];
                        const checkbox = listaCheckbox[contCheckBox];

                        if(checkbox.checked)
                            valor += Math.pow(2, this.$_.parseInt(atributo.valor, 10));
                    }

                    if(pergunta.indicadorMandatorio && valor == 0){
                        consistente = false;
                    }
                    else{
                        this.$set(this.resposta.respostaPergunta[cont], "indicadorMultiplaEscolhaListaValoresAtributo", valor);
                    }
                }
                else if(pergunta.listaValores != null){
                    if(pergunta.listaValores.atributo.length > 8){
                        const select = this.$refs[`resposta-${pergunta.ordem}`];
                        if(select[0].selectedItems.length == 0){
                            consistente = false;
                        }
                        else{
                            this.$set(this.resposta.respostaPergunta[cont], "listaValoresAtributo", select[0].selectedItems[0]);
                        }
                    }
                    else{
                        const listaRadio = form.querySelectorAll(`input[name='resposta-${pergunta.ordem}']`);
                        let checked = false;

                        let atributo = null;
                        for(let contRadio = 0; contRadio < pergunta.listaValores.atributo.length; contRadio++){
                            atributo = pergunta.listaValores.atributo[contRadio];
                            const radio = listaRadio[contRadio];

                            if(radio.checked){
                                checked = true;
                                break;
                            }
                        }

                        if(!checked){
                            consistente = false;
                        }
                        else{
                            this.$set(this.resposta.respostaPergunta[cont], "listaValoresAtributo", atributo);
                        }
                    }
                }
                else{
                    const textarea = form.querySelector(`textarea[name='resposta-${pergunta.ordem}']`);
                    if(this.$_.trim(textarea.value) == "" || this.$_.trim(textarea.value) == undefined){
                        consistente = false;             
                    }
                    else{
                        this.$set(this.resposta.respostaPergunta[cont], "descricao", textarea.value);
                    }
                }
            }

            if(consistente){
                this.inserir(this.resposta);
            }
            else{
                this.showPendency(this.$t("Views.Corporativo.Enquete.Resposta.campos-obrigatorios-pendentes"));                
            }            
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../../../styles/material-dashboard/variables";
    .numeroPergunta{
        font-size: 19px;  
        font-weight: bolder;
    }    
    .textoPergunta{
        font-size: 17px;  
    }        
</style>
